import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { CartProvider } from "./lib/cart";
import { FeaturesProvider } from "./lib/features";
import { queryClient } from "./lib/query";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <FeaturesProvider>
        <CartProvider>
          <RouterProvider router={router} />
        </CartProvider>
      </FeaturesProvider>
    </QueryClientProvider>
  </StrictMode>,
);
